module.exports = __webpack_public_path__ + "img/vulgar.fe001b48.png";